import { useQuery } from '@tanstack/react-query';
import api from '../lib/api';

export interface AdminUserRecord {
  userId: string;
  username: string;
  email: string;
  pais?: string;
  ciudad?: string;
  ratingAvg?: number;
  ratingCount?: number;
  createdAt: string;
}

export interface AdminTradeRecord {
  tradeId: string;
  status: 'PENDING' | 'COMPLETED' | 'REJECTED' | 'CANCELLED' | 'EXPIRED';
  proposerId: string;
  targetId: string;
  createdAt: string;
}

export interface AdminStats {
  summary: {
    totalUsers: number;
    activeUsers7d: number;
    totalTrades: number;
    tradesByStatus: Record<string, number>;
    countries: string[];
  };
  users: AdminUserRecord[];
  trades: AdminTradeRecord[];
  inventory: {
    topDuplicates: { stickerId: string; count: number }[];
  };
}

export function useAdminStats() {
  return useQuery<AdminStats>({
    queryKey: ['admin-stats'],
    queryFn: async () => {
      const { data } = await api.get('/admin/stats');
      return data.data as AdminStats;
    },
    staleTime: Infinity,
    retry: false,
  });
}
